<template>
  <div v-loading="loading" class="material-upload">
    <el-divider></el-divider>

    <ul class="img_list">
      <li v-for="(item, i) in list" :key="i">
        <div class="top">
          <div class="img">
            <img :src="item.preview_url" alt="#" />
            <span class="bg" @click="handleRemove(i)">
              <i class="el-icon-delete" />
            </span>
          </div>
          <div
            class="fr"
            :style="{
              minWidth: 40 + 92 * Math.ceil((item.publicObj.length + 1) / 5) + 'px',
            }"
          >
            <span class="add_toast">添加公众号</span>
            <span v-for="(p, j) in item.publicObj" :key="j" @click="handleDelete(p, j, i)">
              {{ p.label }}
              <div class="three">x</div>
            </span>
            <el-button @click="handleAdd(i)">
              <i class="el-icon-plus avatar-uploader-icon" />
            </el-button>
          </div>
          <div
            class="fr"
            :style="{
              minWidth: 40 + 92 * Math.ceil((item.agentObj.length + 1) / 5) + 'px',
            }"
          >
            <span class="add_toast">添加企业应用</span>
            <span v-for="(p, j) in item.agentObj" :key="j" @click="handleDelete2(p, j, i)">
              {{ p.label }}
              <div class="three">x</div>
            </span>
            <el-button @click="handleAdd2(i)">
              <i class="el-icon-plus avatar-uploader-icon" />
            </el-button>
          </div>
        </div>
        <el-input
          v-model="item.mate_name"
          placeholder="请输入图片名称"
          :maxlength="100"
          @blur="(e) => inputChange(e, 'blur')"
          @focus="(e) => inputChange(e, 'focus')"
        >
          <template slot="append">{{ item.mate_postfix }}</template>
        </el-input>
        <p
          v-if="item.cos_status === 'success' && item.upload_status === 'success'"
          class="uploadTip success"
        >
          上传成功
          <i class="el-icon-success" />
        </p>
        <p
          v-else-if="item.cos_status === 'error' || item.upload_status === 'error'"
          class="uploadTip error"
        >
          上传失败
          <i class="el-icon-error" />
        </p>
      </li>
      <template v-if="list.length < 8">
        <el-upload
          class="avatar-uploader"
          :show-file-list="false"
          action="#"
          :before-upload="beforeAvatarUpload"
          :http-request="httpRequest"
        >
          <i class="el-icon-plus avatar-uploader-icon" />
        </el-upload>
      </template>
    </ul>
    <div class="btns">
      <el-button type="primary" class="btn-width" @click="save">保存</el-button>
      <el-button
        v-show="showback"
        class="btn-width"
        @click="
          () => {
            closeComp('back');
          }
        "
      >
        取消
      </el-button>
    </div>
    <!-- 添加公众号弹窗 -->
    <UserPublic
      :public-value="publicValue"
      :dialog-visible.sync="dialogVisible"
      @emitUserPublic="emitUserPublic"
    />
    <!-- 添加企业应用弹窗 -->
    <UserAgent
      :agent-value="agentValue"
      :dialog-visible.sync="dialogVisible2"
      @emitUserAgent="emitUserAgent"
    />
  </div>
</template>
<script>
import UserPublic from '../user-public';
import UserAgent from '../user-agent';
import { CosMixin } from '@/mixins/cos';
import { EyaoSaaSSynCreateMaterialApi } from '@/api/releaseManagement';
import { postfixFun } from '@/utils/util';

export default {
  name: 'MaterialManagementImageUpload',
  components: {
    UserPublic,
    UserAgent,
  },
  mixins: [CosMixin],
  data() {
    return {
      type: 1, // 类型 1图片 2视频 3音频
      showback: true, // 是否显示返回
      loading: false, // 加载
      list: [], // 列表数据
      currentAdd: null, // 公众号 记录当前操作索引
      publicValue: [], // 公众号 打开弹框回显
      dialogVisible: false, // 公众号 是否显示弹框
      currentAdd2: null, // 企业应用 记录当前操作索引
      agentValue: [], // 企业应用 打开弹框回显
      dialogVisible2: false, // 企业应用 是否显示弹框
    };
  },
  computed: {
    publicList() {
      return this.$store.getters['user/getPublishList'];
    },
    agentList() {
      return this.$store.state.user.managerLogin.agent_list;
    },
  },
  created() {
    this.$store.dispatch('user/getManagerLogin');
    const { query } = this.$route;
    // 判断是否新打开的页面
    if (query.type === 'newWindow') {
      this.showback = false;
    }
  },
  methods: {
    // 公众号----------------------------
    // 转显示格式
    changeShowData() {
      const temp = [];
      for (let j = 0; j < this.publicList.length; j++) {
        if (+this.publicList[j].status === 1) {
          temp.push({
            label: this.publicList[j].app_name,
            value: this.publicList[j].app_id,
          });
        }
        this.list[this.list.length - 1].publicObj = temp;
      }
    },
    // 添加
    handleAdd(i) {
      this.currentAdd = i;
      this.publicValue = this.list[i].publicObj;
      this.dialogVisible = true;
    },
    // 弹窗确定回调
    emitUserPublic(e) {
      this.list[this.currentAdd].publicObj = e;
    },
    // 删除
    handleDelete(item, index, indexi) {
      this.list[indexi].publicObj.forEach((e) => {
        if (e.value === item.value) {
          this.list[indexi].publicObj.splice(index, 1);
        }
      });
    },

    // 企业微信应用----------------------------
    // 转显示格式
    changeShowData2() {
      const temp = [];
      for (let j = 0; j < this.agentList.length; j++) {
        if (+this.agentList[j].close === 0) {
          temp.push({
            label: this.agentList[j].agent_name,
            value: this.agentList[j].agent_id,
          });
        }
        this.list[this.list.length - 1].agentObj = temp;
      }
    },
    // 添加
    handleAdd2(i) {
      this.currentAdd2 = i;
      this.agentValue = this.list[i].agentObj;
      this.dialogVisible2 = true;
    },
    // 弹窗确定回调
    emitUserAgent(e) {
      this.list[this.currentAdd2].agentObj = e;
    },
    // 删除
    handleDelete2(item, index, indexi) {
      this.list[indexi].agentObj.forEach((e) => {
        if (e.value === item.value) {
          this.list[indexi].agentObj.splice(index, 1);
        }
      });
    },

    // 上传前处理
    beforeAvatarUpload(file) {
      let isSupport = true;
      const regExp = 'PNG|JPG|JPEG|BMP|GIF';
      if (!new RegExp(`(${regExp})`, 'i').test(file.type)) {
        this.$message.error(`上传图片仅支持${regExp}格式!`);
        isSupport = false;
      }
      const isSize = file.size / 1024 / 1024 < 10;
      if (!isSize) {
        this.$message.error('上传图片大小不能超过10MB!');
      }
      const success = isSize && isSupport;
      return success;
    },
    // 请求处理
    httpRequest(data) {
      const { prefix, postfix } = postfixFun(data.file.name);
      const obj = {
        publicObj: [], // 公众号选择回调[{label:xx,value:xxx}]
        agentObj: [], // 公众号选择回调[{label:xx,value:xxx}]
        mate_name: prefix,
        mate_postfix: postfix,
        url: '', // cos地址
        file: data.file,
        preview_url: URL.createObjectURL(data.file), // 图片显示地址
        cos_status: 'ready', // cos上传状态 ready(准备上传) error(上传错误) success(上传成功)
        upload_status: 'ready', // 服务器上传状态 ready(准备上传) error(上传错误) success(上传成功)
      };
      this.list.push({ ...obj });
      this.changeShowData();
      this.changeShowData2();
    },
    // 保存 先请求cos, 再请求服务器
    // 1. 上传cos , 上传错误, 改变失败状态
    // 2. 上传服务器, 上传错误, 改变失败状态
    async save() {
      const that = this;
      if (!that.list.length) {
        that.$message.warning(`请上传图片`);
        return;
      }
      const arr = [];
      for (let i = 0; i < that.list.length; i++) {
        if (!that.list[i].mate_name) {
          that.$message.warning(`请输入标题 -[图${i + 1}]`);
          return;
        }
        if (!that.list[i].publicObj.length && !that.list[i].agentObj.length) {
          that.$message.warning(`公众号或企业应用至少选择一个 -[图${i + 1}]`);
          return;
        }
        const obj = { ...that.list[i] };

        // 提取id
        obj.apps = [];
        obj.agents = [];
        that.list[i].publicObj.forEach((item) => {
          obj.apps.push({ app_id: item.value, app_name: item.label });
        });
        that.list[i].agentObj.forEach((item) => {
          obj.agents.push({ agent_id: item.value, agent_name: item.label });
        });

        arr.push({ ...obj });
      }

      that.loading = true;
      const resArr = await that.requestServer(await that.getCosUrl(arr));
      that.list = resArr;

      // 判断是否上传成功
      let count = 0;
      const ilen = resArr.length;
      for (let i = 0; i < ilen; i++) {
        const e = resArr[i];
        if (e.cos_status === 'success' && e.upload_status === 'success') {
          count += 1;
        }
      }
      // 全部上传成功
      setTimeout(() => {
        if (count === ilen) {
          that.closeComp('save');
          that.$message.success('保存成功');
          that.loading = false;
        } else {
          that.$message.error(`${ilen - count}张图保存失败, 请重新保存`);
          that.loading = false;
        }
      }, 0);
    },
    // 上传转换获取cos地址
    getCosUrl(arr) {
      const arrTemp = [...arr];
      return new Promise(async (resolve) => {
        for (let i = 0, ilen = arrTemp.length; i < ilen; i++) {
          const e = arrTemp[i];
          // 准备上传和上传失败可再上传
          if (e.cos_status === 'ready' || e.cos_status === 'error') {
            const cosParams = {
              fileObject: e.file,
            };
            try {
              //   console.time();
              const res = await this.putCosObject(cosParams);
              //   console.timeEnd();
              delete e.file;
              e.url = res.data;
              e.cos_status = res ? 'success' : 'error';
            } catch (error) {
              e.cos_status = 'error';
              //   this.$message.error('COS服务器连接失败');
              //   return;
            }
          }
        }
        resolve(arrTemp);
      });
    },
    // 请求服务器
    async requestServer(arr) {
      const { type } = this;
      const arrTemp = arr;
      return new Promise(async (resolve) => {
        for (let i = 0; i < arrTemp.length; i++) {
          const e = arrTemp[i];
          if (
            e.cos_status === 'success' ||
            e.upload_status === 'ready' ||
            e.upload_status === 'error'
          ) {
            try {
              // cos上传失败, mate_data为空, 不走服务器
              if (!e.url) break;
              const res = await EyaoSaaSSynCreateMaterialApi({
                mate_infos: [
                  {
                    mate_type: type,
                    mate_name: e.mate_name + e.mate_postfix,
                    mate_data: e.url,
                    apps: e.apps,
                    agents: e.agents,
                  },
                ],
              });
              if (!res.error) {
                e.upload_status = 'success';
              } else {
                e.upload_status = 'error';
              }
            } catch (error) {
              e.upload_status = 'error';
            }
          }
        }
        resolve(arrTemp);
      });
    },
    // 删除图片
    handleRemove(i) {
      this.list.splice(i, 1);
    },
    // 修改文字
    inputChange(e, item) {
      // 获取焦点
      if (item === 'focus') {
        e.target.setAttribute('class', 'el-input__inner focus');
      } else {
        // 失去焦点
        e.target.setAttribute('class', 'el-input__inner');
      }
    },
    // 隐藏组件  val = 'back'(返回)  'save'(保存或发布)
    closeComp() {
      // 如果是素材库管理, 跳转回素材库管理
      if (this.$route.path.includes('materialManagement')) {
        this.g_tourl(`/saas/materialManagement.html`);
      } else {
        console.log('here');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.material-upload {
  .back {
    height: 84px;
    line-height: 84px;
    font-size: 18px;
    color: #313233;
    cursor: pointer;
    span {
      float: left;
      margin-right: 16px;
    }
    .gray {
      font-size: 16px;
      color: #606266;
    }
  }
  .btns {
    text-align: center;
    margin-top: 100px;
    .btn-width {
      //   margin-left: 0;
      width: 148px;
      height: 48px;
    }
  }
  .avatar-uploader {
    width: 142px;
    height: 142px;
    background: #f0f2f5;
    display: inline-block;
    vertical-align: top;
    .avatar-uploader-icon {
      font-size: 28px;
      color: #c0c4cc;
      width: 100%;
      height: 100%;
      line-height: 142px;
      text-align: center;
    }
  }
  .img_list {
    li {
      display: inline-block;
      margin-right: 16px;
      margin-bottom: 16px;
      .el-input {
        width: 100%;
      }
      ::v-deep .el-input__inner {
        width: 100%;
        height: 26px;
        border-radius: 4px 0 0 4px;
        //   border: 0 none;
        //   &:hover {
        //     border: 1px solid #c0c4cc;
        //   }
        //   &.focus {
        //     border: 1px solid #c0c4cc;
        //   }
      }
      .top {
        border: 1px solid rgba(48, 49, 51, 0.08);
        height: 142px;
        display: flex;
        margin-bottom: 8px;
        .img {
          width: 142px;
          height: 100%;
          position: relative;
          &:hover .bg {
            display: block;
          }
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
          .bg {
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            background: rgba(0, 0, 0, 0.7);
            text-align: center;
            color: #fff;
            font-size: 18px;
            line-height: 142px;
            display: none;
            i {
              cursor: pointer;
            }
          }
        }
        .fr {
          display: flex;
          flex-wrap: wrap;
          writing-mode: vertical-lr;
          padding: 2px 0 10px 16px;
          span {
            writing-mode: horizontal-tb;
            padding-top: 9px;
            font-size: 16px;
            line-height: 16px;
            color: #303133;
            margin-right: 12px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            cursor: pointer;
            &.add_toast {
              color: #909399;
            }
          }
          .three {
            display: inline-block;
            vertical-align: bottom;
            font-size: 15px;
            padding-left: 5px;
            color: #ff602e;
            visibility: hidden;
          }
          &:hover {
            .three {
              visibility: inherit;
            }
          }
          button {
            background: #f5f7fa;
            border: 1px solid #d8dce6;
            border-radius: 4px;
            width: 40px;
            height: 20px;
            padding: 0;
            margin-top: 8px;
            margin-right: 8px;
          }
          ::v-deep .el-button span {
            font-size: 12px;
          }
        }
      }
      .mate_name {
        font-size: 14px;
        color: #606266;
        cursor: pointer;
      }
    }
  }
  // 上传状态文字提示
  .uploadTip {
    font-size: 14px;
    padding: 0 14px;
    &.success {
      color: #67c23a;
    }
    &.error {
      color: #f56c6c;
    }
  }
}
::v-deep .el-upload {
  display: block;
}
</style>
